export interface GoogleSlidesUrlValidationResult {
  valid: boolean;
  presentationId?: string;
  normalizedUrl?: string;
}

const PRESENTATION_ID_REGEX = /^[a-zA-Z0-9_-]+$/;

export function validateGoogleSlidesUrl(url: string): GoogleSlidesUrlValidationResult {
  const trimmed = url.trim();
  if (!trimmed) {
    return { valid: false };
  }

  // Prepend https:// if no protocol is present so URL can be parsed.
  // We always normalize to https:// in the output regardless.
  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

  try {
    const parsed = new URL(withProtocol);

    const isGoogleDocs =
      parsed.hostname === 'docs.google.com' || parsed.hostname === 'www.docs.google.com';
    if (!isGoogleDocs) {
      return { valid: false };
    }

    const idMatch = parsed.pathname.match(/^\/presentation\/d\/([a-zA-Z0-9_-]+)/);
    if (!idMatch || !PRESENTATION_ID_REGEX.test(idMatch[1])) {
      return { valid: false };
    }

    const presentationId = idMatch[1];
    return {
      valid: true,
      presentationId,
      normalizedUrl: `https://docs.google.com/presentation/d/${presentationId}/edit`,
    };
  } catch {
    return { valid: false };
  }
}
